<template>
  <div class="tour-host">
    <div class="tour-host__info">
      <div href="javascript:void(0);" @click.stop.prevent="openExpertPage" :title="expertData.name" target="_blank" class="tour-host__avatar u-flex-shrink-0">
        <avatar :name="expertData.name" :photo="expertData.avatar" />
      </div>
      <div
        @click.stop.prevent="openExpertPage"
        target="_blank"
        class="tour-host__info-container font-semibold"
      >
        <div class="tour-host__info-top">
          <span class="tour-host__name">{{ expertData.name }}</span>
          <button-icon v-if="expertData.count_reviews" tag="span" size="sm">
            <template #icon>
              <icon icon="star" />
            </template>
            {{ expertData.rating_expert }}
          </button-icon>
        </div>
        <div class="u-text-secondary">{{ $t("common.organizer") }}</div>
        <Awards
          v-if="getAwards"
          :name="getAwards.name"
          :code="getAwards.code"
        />
      </div>

    </div>
    <div class="tour-host__ask">
      <yt-button
        class="tour-host__ask-button"
        :color="getChatButtonClass"
        squared
        @click="clickAskButton"
      >
        {{ $t("common.contact") }}
      </yt-button>
      <popup-contact-travel-expert
        v-model="popups.ask"
        :expert-data="expertData"
        :trip-id="tripId"
      />
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/ui-kit/avatar/index.vue";
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import Icon from "@/components/icons/index.vue";
import YtButton from "@/components/ui-kit/yt-button/index.vue";
import PopupContactTravelExpert from "@/components/organisms/contact-travel-expert/popup.vue";
import Awards from "@/components/ui-kit/awards/index.vue";
import {abTestController} from "@/plugins/abtest";
import {ytEvents} from "@/plugins/analytics";

export default {
  components: {
    Avatar,
    ButtonIcon,
    Icon,
    YtButton,
    PopupContactTravelExpert,
    Awards,
  },
  props: {
    expertData: {
      type: Object,
      required: true,
    },
    tripId: {
      type: [String, Number],
      required: true,
    },
    awards: {
      type: Object,
    }
  },
  data() {
    return {
      popups: {
        ask: false,
      },
    };
  },
  computed: {
    getAwards()
    {
      return this.awards.code === 'best_expert' ? this.awards : false;
    },
    link() {
      return this.expertData?.link;
    },
    getChatButtonClass() {
      return this.isAbTest15919() ? 'violet' : 'gray';
    },
  },
  methods: {
    openExpertPage(event) {
      event.preventDefault(); // Предотвращаем стандартное поведение клика
      event.stopPropagation(); // Останавливаем всплытие события
      fakeWindow.open(this.link, '_blank').focus();
    },
    isAbTest15919() {
      return abTestController.getSegment(15919) === 'B'
    },
    clickAskButton() {
      this.popups.ask = true;
      ytEvents.track("Tour detail" , "Click Message to expert button",);
      if (typeof window.youtravel.DataCollector !== "undefined") {
        window.youtravel.DataCollector.trackEvent("Tour detail", "Click Message to expert button", {
          'tour_id': this.tripId || "",
          'list': "",
          'filter': {},
          'additional': {},
          'meta': {}
        })
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.tour-host {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__info {
    display: flex;
    align-items: center;

    &-container {
      display: block;
      color: var.$black;
    }

    &-top {
      margin-bottom: 2px;
    }
  }

  &__avatar {
    display: block;
    cursor: pointer;
    width: 56px;
    margin-right: 12px;
  }

  &__name {
    cursor: pointer;
    padding-right: 4px;
  }

  &__ask {
    margin-left: 10px;

    &-button {
      white-space: nowrap;
    }
  }
}
</style>
